import { Fragment, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Tooltip from 'components/tooltip/Tooltip'
import { OperationStatus } from 'features/Codes'
import PropTypes from 'prop-types'
import { modifyAdAccountOnOff } from 'features/account/accountSlice'
import Switch from 'components/form/Switch'
import { success } from '../toast/Toast'

export const getStatus = accountStatus => {
  const result = []
  if (accountStatus.includes('OPERATING')) {
    result.push(OperationStatus.ON)
  }
  if (accountStatus.includes('STOPPED')) {
    result.push(OperationStatus.OFF_BY_AD_ACCOUNT_ADMIN_STOP)
  }
  if (accountStatus.includes('OFF')) {
    result.push(OperationStatus.OFF_BY_AD_ACCOUNT)
  }
  if (accountStatus.includes('OUT_OF_BALANCE')) {
    result.push(OperationStatus.OFF_BY_AD_ACCOUNT_USER_BALANCE)
  }
  if (accountStatus.includes('NOT_CONNECTED_BIZ_WALLET')) {
    result.push(OperationStatus.OFF_BY_NOT_CONNECTED_BIZ_WALLET)
  }
  return result
}

const AccountOffStatusTooltip = ({ status }) => {
  const { adminStopLog } = useSelector(({ account }) => ({
    adminStopLog: account.current?.adminStopLog,
  }))
  const offStatus = useMemo(
    () => status.filter(item => item.name !== OperationStatus.ON.name),
    [status]
  )
  const [first] = offStatus
  return first ? (
    <Tooltip
      position="bottom"
      display="inline"
      nowrap={false}
      content={offStatus.map((item, index) => (
        <Fragment key={index}>
          <strong className="tit_tooltip">운영 불가({item.title})</strong>
          <p className="desc_tooltip">{item.msg}</p>
          {item.name === OperationStatus.OFF_BY_AD_ACCOUNT_ADMIN_STOP.name &&
            adminStopLog && (
              <p className="desc_tooltip">{adminStopLog.adminStopReason}</p>
            )}
        </Fragment>
      ))}>
      운영 불가(
      {offStatus.length > 1 ? offStatus.length : first.title})
    </Tooltip>
  ) : (
    <Fragment />
  )
}
AccountOffStatusTooltip.propTypes = {
  status: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
      msg: PropTypes.string,
    })
  ),
}

const AdAccountManager = () => {
  const {
    current: { id, userConfig, status: accountStatus },
    isLoading,
  } = useSelector(state => state.account)
  const dispatch = useDispatch()
  const status = useMemo(() => getStatus(accountStatus), [accountStatus])
  const handleOnOff = async () => {
    await dispatch(
      modifyAdAccountOnOff({
        adAccountId: id,
        state: userConfig === 'ON' ? 'OFF' : 'ON',
      })
    )
    success('광고계정 변경사항이 적용되었습니다.')
  }
  return (
    <div className="ad_info">
      <div className="item_info">
        <strong className="tit_item">광고계정 ID</strong>
        <div className="txt_item">{id}</div>
      </div>
      <div className="item_info">
        <strong className="tit_item">ON/OFF</strong>
        <div className="txt_item">
          <Switch
            className="txt_item"
            isLoading={isLoading}
            deleted={false}
            status={userConfig || 'OFF'}
            onChange={handleOnOff}
          />
        </div>
      </div>
      <div className="item_info">
        <strong className="tit_item">상태</strong>
        <div className="txt_item">
          <p className="txt_state">
            {status.length === 1 && status[0] === OperationStatus.ON ? (
              <>
                <span className="ico_on" />
                운영 가능
              </>
            ) : (
              <>
                <span className="ico_off" />
                <AccountOffStatusTooltip status={status} />
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  )
}
export default AdAccountManager
